import React from "react";
import { courseDuck } from "features/course/CourseDuck";
import { useI18n } from "components/lni18n";
import { Progress } from 'reactstrap';
import LnIcon from "components/LnIcon";
import DOMPurify from 'dompurify';

const EvalStatistics = (props) => {
    const part = courseDuck.useCurrentPart();
    const { languageService: t } = useI18n();


    if (!part || !part.Eval) {
        return null;
    }

    if (!part.Eval.Submitted) {
        return null;
    }



    return <div className="max-col-width">
        {part.Goals !== null && part.Goals !== "" &&
            <div className="mb-3">
                <h3>
                    {t.getText("coursepart.goals")}
                </h3>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(part.Goals) }}></div>
                <hr />
            </div>
        }

        <div className="mb-5">
            <LnIcon name="checked" className="mr-4 icon-medium" />
            {t.getText("evaluation_already_posted")}
        </div>

        {(part.Eval.Stats && part.Eval.Stats.Questions && part.Eval.Stats.Questions.length) ? part.Eval.Stats.Questions.map((q, i) => {

            return (<div key={i} className="mb-4">
                <div className="alert alert-grey d-flex">
                    <div className="mr-3">{(i + 1)}</div>
                    <div className="ml-3" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(q.Text) }}></div>
                </div>
                {q.AnswerType === "freetext" && q.Answers && q.Answers.length > 0 &&
                    <FreetextAnwsers answers={q.Answers} languageService={t} />}

                {q.AnswerType === "multiplechoice" && q.Numbers != null &&
                    <MCAnwsers question={q} languageService={t} />}
            </div>);

        }) : null}
    </div>
}

const FreetextAnwsers = ({ answers, languageService }) => {

    return answers.map((a,i) => (<div key={i} className="ml-3 d-flex">
        <div className="mr-4">
            {languageService.getShortDateString(a.Date)}
        </div>
        <div className="">
            {a.Text}
        </div>
    </div>
    ));
}

const MCAnwsers = ({ question, languageService }) => {

    const scores = Array.isArray(question.Options) ? question.Options.map(o => o.Score) : [];
    const min = scores.length > 0
        ? Math.min(...scores)
        : (question?.Numbers?.MinValue ?? 0);

    const [folded, setFolded] = React.useState(true);

    return <div className="ml-3">

        <div className="mb-3">

            {question.Options && question.Options.length > 0 && <>
                <button type="button" className="btn btn-link" onClick={() => setFolded(f => !f)} >
                    {languageService.getText("options")}
                    <span className={`mt-1 ml-2 ${folded ? "dark-caret" : "dark-caret-point-left"}`}></span>
                </button>
                {!folded &&
                    <table className="mt-3 table table-sm">
                        <tbody>
                            {question.Options.map((o, i) => (
                                <tr key={o.Id ?? i}>
                                    <td>{o.Score}</td>
                                    <td dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize( o.AnswerText ) }} />
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }

            </>
            }
        </div>

        <div className="mt-3">
            <LnIcon name="user" className="icon-medium filter-primary" /> {question.NumActiveStudents} {languageService.getText("students")}
            <LnIcon name="answers-bubble" className="ml-4 icon-medium filter-primary" /> {question.ClassAnswerCount} {languageService.getText("answers")} 
             (
              {question.NumActiveStudents > 0
                ? Math.round(100 * question.ClassAnswerCount / question.NumActiveStudents)
                : 0}%
            )
        </div>


        <div className="row">
            <div className="col-4">
                <small>
                    {languageService.getText("mark.scale")} {min} - {question.Numbers.MaxValue}
                </small>
            </div>
            <div className="col-8 d-flex align-items-center justify-content-end">
                <Progress className="mr-2 flex-fill" color="success" value={question.Numbers.ClassAverageInPercent} />
                <small>{question.Numbers.ClassAverage.toFixed(2)}</small>
            </div>

        </div>


    </div>
}


export default EvalStatistics;